import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import {
  getMediaAttributes,
  getResizableAttributes,
  isHTMLElementNode,
} from '../helpers/serializerHelpers';
import { type VideoElement } from '../../types/aha-editor';
import { isVideoElement } from '../../types/guards';

class SerializerVideo extends Serializer {
  static deserialize({ el }: DeserializeArguments): VideoElement | undefined {
    if (!isHTMLElementNode(el) || el.tagName.toLowerCase() !== 'video') return;

    return {
      type: 'video',
      children: [{ text: '' }],
      ...getResizableAttributes(el),
      ...getMediaAttributes(el),
    };
  }

  static serialize({ node }: SerializeArguments): React.ReactNode {
    if (!isVideoElement(node)) return;

    const {
      resizer_width,
      resizer_height,
      resizer_originalWidth,
      resizer_originalHeight,
      media_src,
      media_position,
      media_alt,
    } = node;

    return (
      <video
        width={resizer_width}
        height={resizer_height}
        data-original-width={resizer_originalWidth}
        data-original-height={resizer_originalHeight}
        data-position={media_position}
        src={media_src}
        controls={true}
        aria-label={media_alt}
      />
    );
  }
}

export default SerializerVideo;
